import cinemapro from "../../../Assets/image/cinemapro.webp";
import cinestore from "../../../Assets/image/cinestore.webp";
import doctor from "../../../Assets/image/Doctor.webp";
import ddcet from "../../../Assets/image/ddcet.webp";
import bizconnect from "../../../Assets/image/bizconnect.webp";
import webDevImg from "../../../Assets/image/services/web-app-development.webp";
import mobileDevImg from "../../../Assets/image/services/mobile-app-development.webp";
import saasDevImg from "../../../Assets/image/services/custom-software-development.webp";
import aiAgentImg from "../../../Assets/image/ai-agent-development.webp";
import genAiImg from "../../../Assets/image/gen-ai-solution.webp";
import aiIntegrationImg from "../../../Assets/image/services/ai-integration-services.webp";
import staffAugImg from "../../../Assets/image/staff-augmentation.webp";

export interface SubTab {
  id: number;
  name: string;
  product_id?: number;
  path?: string;
  img?: string;
  brief?: string;
}

export interface Tab {
  id: number;
  name: string;
  path?: string;
  subTabs?: SubTab[];
}

export const footerTabs: Tab[] = [
  {
    id: 1,
    name: "Company",
    subTabs: [
      { id: 1.1, name: "About Us", path: "/about" },
      {
        id: 1.2,
        name: "Our Work",
        path: "/our-work",
      },
      {
        id: 1.3,
        name: "Case Studies",
        path: "/case-studies",
      },
      {
        id: 1.4,
        name: "Articles",
        path: "/articles",
      },
      {
        id: 1.5,
        name: "Blogs",
        path: "/blogs",
      },
      {
        id: 1.6,
        name: "Hire A Developer",
        path: "/hire-a-developer",
      },
      {
        id: 1.7,
        name: "Careers",
        path: "/careers",
      },
      {
        id: 1.8,
        name: "Contact US",
        path: "/contact-us",
      },
    ],
  },
  {
    id: 2,
    name: "Services",
    subTabs: [
      {
        id: 2.1,
        name: "Web Development",
        path: "/web-development-company",
        img: webDevImg,
        brief:
          "Transform your digital presence with cutting-edge web development. We craft responsive, high-speed, and conversion-driven websites designed to maximize engagement, enhance user experience, and drive business growth.",
      },
      {
        id: 2.2,
        name: "Mobile Development",
        path: "/mobile-app-development-company",
        img: mobileDevImg,
        brief:
          "Turn your app idea into a reality with high-performance, feature-rich mobile applications for iOS and Android. We focus on user-centric design, scalability, and advanced functionality to ensure a seamless mobile experience.",
      },
      {
        id: 2.3,
        name: "Custom SaaS Development",
        path: "/custom-saas-development-company",
        img: saasDevImg,
        brief:
          "Build cloud-based, multi-tenant Software-as-a-Service (SaaS) platforms with robust subscription billing, security, and scalability.",
      },
      {
        id: 2.4,
        name: "AI Agent Development",
        path: "/ai-agent-development-company",
        img: aiAgentImg,
        brief:
          "Deploy intelligent, autonomous AI agents capable of reasoning, execution, task automation, and integration with your workflows.",
      },
      {
        id: 2.5,
        name: "Gen AI Solutions",
        path: "/generative-ai-solutions-company",
        img: genAiImg,
        brief:
          "Leverage LLMs, image generation models, and retrieval-augmented generation (RAG) to build custom generative AI applications.",
      },
      {
        id: 2.6,
        name: "AI Integration Services",
        path: "/ai-integration-services-company",
        img: aiIntegrationImg,
        brief:
          "Infuse AI capabilities into your existing software, databases, and APIs for smarter analytics and decision-making.",
      },
      {
        id: 2.7,
        name: "Staff Augmentation",
        path: "/hire-a-developer",
        img: staffAugImg,
        brief:
          "We provide skilled professionals to extend your team and meet your project goals. Our experts are ready to integrate seamlessly with your workflows.",
      },
    ],
  },
  {
    id: 3,
    name: "Products",
    subTabs: [
      {
        id: 3.1,
        product_id: 1,
        name: "CinemaPro",
        img: cinemapro,
        brief:
          "CinemaPro is a premium platform designed to help film industry professionals manage their projects seamlessly, offering tools for collaboration, scheduling, and production tracking.",
      },
      /* {
        id: 3.2,
        name: "MediCare Pro",
        product_id: 2,
        img: doctor,
        brief:
          "Doctor is a comprehensive clinic management platform that streamlines patient care, appointment scheduling, billing, and medical records management, improving the overall healthcare experience.",
      }, */
      {
        id: 3.3,
        name: "DDCET",
        product_id: 3,
        img: ddcet,
        brief:
          "DDCET is a comprehensive, multi-tenant exam preparation platform designed for diploma students in Gujarat, India, offering bilingual study materials and real exam mock tests.",
      },
      {
        id: 3.4,
        name: "BizConnect",
        product_id: 4,
        img: bizconnect,
        brief:
          "BizConnect is a comprehensive, multi-tenant e-commerce platform allowing merchants to set up storefronts, customize designs, and manage B2B/B2C retail and wholesale operations.",
      },
    ],
  },
];

export const navTabs: Tab[] = [
  {
    id: 1,
    name: "Company",
    subTabs: [
      { id: 1.1, name: "About Us", path: "/about" },
      {
        id: 1.2,
        name: "Our Work",
        path: "/our-work",
      },
      {
        id: 1.3,
        name: "Case Studies",
        path: "/case-studies",
      },
      {
        id: 1.4,
        name: "Articles",
        path: "/articles",
      },
      {
        id: 1.5,
        name: "Blogs",
        path: "/blogs",
      },
      {
        id: 1.6,
        name: "Careers",
        path: "/careers",
      },
    ],
  },
  {
    id: 2,
    name: "Services",
    subTabs: [
      {
        id: 2.1,
        name: "Web Development",
        path: "/web-development-company",
        img: webDevImg,
        brief:
          "Transform your digital presence with cutting-edge web development. We craft responsive, high-speed, and conversion-driven websites designed to maximize engagement, enhance user experience, and drive business growth.",
      },
      {
        id: 2.2,
        name: "Mobile Development",
        path: "/mobile-app-development-company",
        img: mobileDevImg,
        brief:
          "Turn your app idea into a reality with high-performance, feature-rich mobile applications for iOS and Android. We focus on user-centric design, scalability, and advanced functionality to ensure a seamless mobile experience.",
      },
      {
        id: 2.3,
        name: "Custom SaaS Development",
        path: "/custom-saas-development-company",
        img: saasDevImg,
        brief:
          "Build cloud-based, multi-tenant Software-as-a-Service (SaaS) platforms with robust subscription billing, security, and scalability.",
      },
      {
        id: 2.4,
        name: "AI Agent Development",
        path: "/ai-agent-development-company",
        img: aiAgentImg,
        brief:
          "Deploy intelligent, autonomous AI agents capable of reasoning, execution, task automation, and integration with your workflows.",
      },
      {
        id: 2.5,
        name: "Gen AI Solutions",
        path: "/generative-ai-solutions-company",
        img: genAiImg,
        brief:
          "Leverage LLMs, image generation models, and retrieval-augmented generation (RAG) to build custom generative AI applications.",
      },
      {
        id: 2.6,
        name: "AI Integration Services",
        path: "/ai-integration-services-company",
        img: aiIntegrationImg,
        brief:
          "Infuse AI capabilities into your existing software, databases, and APIs for smarter analytics and decision-making.",
      },
      {
        id: 2.7,
        name: "Staff Augmentation",
        path: "/hire-a-developer",
        img: staffAugImg,
        brief:
          "We provide skilled professionals to extend your team and meet your project goals. Our experts are ready to integrate seamlessly with your workflows.",
      },
    ],
  },
  {
    id: 3,
    name: "Products",
    subTabs: [
      {
        id: 3.1,
        product_id: 1,
        name: "CinemaPro",
        img: cinemapro,
        brief:
          "CinemaPro is a premium platform designed to help film industry professionals manage their projects seamlessly, offering tools for collaboration, scheduling, and production tracking.",
      },
      /* {
        id: 3.2,
        name: "MediCare Pro",
        product_id: 2,
        img: doctor,
        brief:
          "Doctor is a comprehensive clinic management platform that streamlines patient care, appointment scheduling, billing, and medical records management, improving the overall healthcare experience.",
      }, */
      {
        id: 3.3,
        name: "DDCET",
        product_id: 3,
        img: ddcet,
        brief:
          "DDCET is a comprehensive, multi-tenant exam preparation platform designed for diploma students in Gujarat, India, offering bilingual study materials and real exam mock tests.",
      },
      {
        id: 3.4,
        name: "BizConnect",
        product_id: 4,
        img: bizconnect,
        brief:
          "BizConnect is a comprehensive, multi-tenant e-commerce platform allowing merchants to set up storefronts, customize designs, and manage B2B/B2C retail and wholesale operations.",
      },
    ],
  },
  { id: 6, name: "Technologies", path: "/technologies" },
  { id: 4, name: "Hire A Developer", path: "/hire-a-developer" },
  { id: 5, name: "Contact Us", path: "/contact-us" },
];
